import { render, staticRenderFns } from "./UnitForm.vue?vue&type=template&id=4bb27c49&scoped=true"
import script from "./UnitForm.vue?vue&type=script&lang=js"
export * from "./UnitForm.vue?vue&type=script&lang=js"
import style0 from "./UnitForm.vue?vue&type=style&index=0&id=4bb27c49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb27c49",
  null
  
)

export default component.exports